import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';

type Variables = { id: number };
export type ResetReservationPaymentIntent = {};

export const useResetReservationPaymentIntent = createMutation<
  ResetReservationPaymentIntent,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: `v2/reservations/${variables.id}/reset-payment-intent`,
      method: 'POST',
    }).then((response) => response.data),
});
